import script from "./cache-use-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./cache-use-popup.vue?vue&type=script&lang=ts&setup=true"

import "./cache-use-popup.vue?vue&type=style&index=0&id=ca010978&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca010978"]])

export default __exports__